import {
  FormElementConditionType,
  FormElementEventTrigger,
  FormElementEventType,
  FormResponseStatus,
  FormRuleType,
  HousingApplicationStatus,
  HousingIntakeScenarioProcessedApplicationStatus,
  PricingType,
} from "~/api";

// Existing type — unchanged
export type EnumDisplayNames<T extends number | string> = {
  [K in T]: string;
};

// New type for maps that intentionally hide legacy entries
export type EnumDisplayNamesWithHidden<T extends number | string> = {
  [K in T]: string | null; // null = legacy/hidden
};

export const conditionDisplayNames: EnumDisplayNames<FormElementConditionType> =
  {
    [FormElementConditionType.ANSWER_EQUALS]: "=",
    [FormElementConditionType.ANSWER_NOT_EQUALS]: "≠",
    [FormElementConditionType.ANSWER_CONTAINS]: "Contains",
    [FormElementConditionType.ANSWER_NOT_CONTAINS]: "Doesn't Contain",
    [FormElementConditionType.ANSWER_HAS_ANY_VALUE]: "Has Any Value",
    [FormElementConditionType.ANSWER_HAS_NO_VALUE]: "Has No Value",
    // [FormElementConditionType.FORM_STATUS_EQUALS]: "Form status =",
    // [FormElementConditionType.FORM_STATUS_GREATER_THAN]: "Form status >",
    // [FormElementConditionType.FORM_STATUS_LESS_THAN]: "Form status <",
    [FormElementConditionType.COUNT_EQUALS]: "Count Equals",
    [FormElementConditionType.COUNT_NOT_EQUALS]: "Count Not Equals",
  };

export const formResponseStatusDisplayNames: EnumDisplayNames<FormResponseStatus> =
  {
    [FormResponseStatus.NEW]: "New",
    [FormResponseStatus.DRAFT]: "Draft",
    [FormResponseStatus.NOT_SENT]: "Not Sent",
    [FormResponseStatus.READY_FOR_SUBMISSION]: "Ready For Submission",
    [FormResponseStatus.SUBMITTED]: "Submitted",
  };

export const sectionRuleTypeDisplayNames: EnumDisplayNames<FormRuleType> = {
  [FormRuleType.IS_RESTRICTED_TO]: "Restricted Access",
  [FormRuleType.REQUIRES_APPROVAL]: "Approvals",
  [FormRuleType.REQUIRES_REVIEW]: "Reviews",
};

export const formElementEventTriggerDisplayNames: EnumDisplayNames<FormElementEventTrigger> =
  {
    [FormElementEventTrigger.ON_SAVE]: "On Save",
  };
export const formElementEventTypeDisplayNames: EnumDisplayNames<FormElementEventType> =
  {
    [FormElementEventType.SUM_TO]: "Sum Of",
    [FormElementEventType.PERCENTAGE_TO]: "Percentage Of",
    [FormElementEventType.CUSTOM_EXPRESSION]: "Custom Expression",
  };

// Retype only this map — other maps stay as EnumDisplayNames<...>
export const housingApplicationStatusDisplayNamesHMBSite: EnumDisplayNamesWithHidden<HousingApplicationStatus> =
  {
    [HousingApplicationStatus.DRAFT]: "Draft",
    [HousingApplicationStatus.NEW]: "New",
    [HousingApplicationStatus.IN_REVIEW]: "In Review",
    [HousingApplicationStatus.WAITLIST]: "Waitlist",
    [HousingApplicationStatus.LOCKED_INTERVIEWING]: "Locked - Processing",
    [HousingApplicationStatus.OFFER_ACCEPTED]: "Offer Accepted",
    [HousingApplicationStatus.HOUSED]: "Housed",
    [HousingApplicationStatus.ON_HOLD]: "On Hold",
    [HousingApplicationStatus.CANCELLED]: "Cancelled",
    // Legacy — hidden from UI
    [HousingApplicationStatus.LOCKED_WITH_OFFER]: null,
    [HousingApplicationStatus.SUBMITTED]: null,
    [HousingApplicationStatus.ASSIGNED]: null,
    [HousingApplicationStatus.PRSCOMPLETED]: null,
    [HousingApplicationStatus.INTAKE]: null,
    [HousingApplicationStatus.OFFER_ACTIVE]: null,
    [HousingApplicationStatus.WAITLISTED]: null,
    [HousingApplicationStatus.OFFER_REJECTED]: null,
    [HousingApplicationStatus.CANCELED]: null,
  };

export const housingIntakeScenarioProcessedApplicationStatusDisplayNames: EnumDisplayNames<HousingIntakeScenarioProcessedApplicationStatus> =
  {
    [HousingIntakeScenarioProcessedApplicationStatus.ACCEPTED]:
      "Offer Accepted",
    [HousingIntakeScenarioProcessedApplicationStatus.NO_OFFER]: "No Offer",
    [HousingIntakeScenarioProcessedApplicationStatus.REJECTED]: "Strike",
    [HousingIntakeScenarioProcessedApplicationStatus.INTERVIEWING]:
      "Interviewing",
    // needs to be removed - after migration or the page is broken
    [HousingIntakeScenarioProcessedApplicationStatus.INTAKE]: "Interviewing",
    [HousingIntakeScenarioProcessedApplicationStatus.CANCELLED]: "Cancelled",
    [HousingIntakeScenarioProcessedApplicationStatus.OFFER_IN_PROGRESS]:
      "Offer in Progress",
    [HousingIntakeScenarioProcessedApplicationStatus.THIRD_STRIKE]:
      "3rd Strike",
    [HousingIntakeScenarioProcessedApplicationStatus.INELIGIBLE]: "Ineligible",
    [HousingIntakeScenarioProcessedApplicationStatus.OFFER_REJECTED]:
      "Offer Rejected",
    [HousingIntakeScenarioProcessedApplicationStatus.NO_OFFER_CANCELLED]:
      "No Offer Cancelled",
  };

export const housingApplicationStatusDisplayNamesPublicSite: EnumDisplayNames<HousingApplicationStatus> =
  {
    [HousingApplicationStatus.DRAFT]: "Draft",
    [HousingApplicationStatus.NEW]: "Submitted",
    [HousingApplicationStatus.IN_REVIEW]: "Submitted",
    [HousingApplicationStatus.WAITLIST]: "Waitlisted",
    [HousingApplicationStatus.LOCKED_INTERVIEWING]: "Waitlisted",
    [HousingApplicationStatus.LOCKED_WITH_OFFER]: "Waitlisted",
    [HousingApplicationStatus.ON_HOLD]: "On Hold",
    [HousingApplicationStatus.HOUSED]: "Housed",
    [HousingApplicationStatus.CANCELLED]: "Cancelled",
    [HousingApplicationStatus.SUBMITTED]: "",
    [HousingApplicationStatus.ASSIGNED]: "",
    [HousingApplicationStatus.PRSCOMPLETED]: "",
    [HousingApplicationStatus.INTAKE]: "",
    [HousingApplicationStatus.OFFER_ACTIVE]: "",
    [HousingApplicationStatus.OFFER_ACCEPTED]: "",
    [HousingApplicationStatus.WAITLISTED]: "",
    [HousingApplicationStatus.OFFER_REJECTED]: "",
    [HousingApplicationStatus.CANCELED]: "",
  };

export const housingSitePricingTypeDisplayNames: EnumDisplayNames<PricingType> =
  {
    [PricingType.MARKET]: "Market",
    [PricingType.RGI]: "RGI - 30%",
    [PricingType.SUPPORT]: "Supportive Living",
  };
